import { Button } from '@mui/material';
import { AlertDialog } from 'src/components';
import { useCustomDashboardContext } from 'src/contexts/customDashboardContext/customDashboard.context';
import { DASHBOARD_TEST_LABELS } from '../../constants';

type Props = {
  onConfirm: () => void;
  isOpen: boolean;
  onClose: () => void;
};

export const DeleteDashboardDialog = ({ onConfirm, isOpen, onClose }: Props) => {
  const { title } = useCustomDashboardContext();

  return (
    <AlertDialog
      testId="disconnect-gateway-popup"
      open={isOpen}
      onClick={onClose}
      title={title}
      customContent={
        <>Do you wish to permanently delete the dashboard {title}? This cannot be undone.</>
      }
      action={
        <>
          <Button
            sx={{
              mr: 2,
              color: (theme) => theme.palette.grey[700],
              borderColor: (theme) => theme.palette.grey[700],
              '&:hover': {
                borderColor: (theme) => theme.palette.grey[500],
                color: (theme) => theme.palette.grey[500],
                backgroundColor: 'transparent',
              },
            }}
            variant="outlined"
            onClick={onClose}
            data-sm="cancel-button"
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="outlined"
            onClick={onConfirm}
            data-sm={DASHBOARD_TEST_LABELS.DIALOG_DELETE_BUTTON}
          >
            Delete Dashboard
          </Button>
        </>
      }
      onClose={onClose}
    />
  );
};
